import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { Icon } from '@components/icons';
import { useTranslation } from 'react-i18next';

const CancelCardSubmitModal = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'cancel_card_submit'
    });
    return (
        <div className={styles.wrapper}>
            <Icon name="error_outlined" width={60} height={60} />
            <Typography className={styles.title} variant="h5">
                {t('title')}
            </Typography>
        </div>
    );
};

export default CancelCardSubmitModal;
